import { useSelector } from "react-redux";
import { TypeArchive } from "../../enums/enums";
import { AppState } from "../../redux/reducers/rootReducer";
import { FuidScreen } from "./FuidScreen";
export const UnaccountedFilesScreen = () => {
  const { expedients } = useSelector( (state: AppState)  => state.fileModule);
  const expedientsByTransferType = expedients?.filter( exp => exp?.deposit === null );
  return <FuidScreen typeExpedients={ expedientsByTransferType }  fromModule={TypeArchive.MANAGEMENT_FILE} />;
};
